import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const newApplicationFormValidation = getFormValidator(
  object().shape({
    account: string().required(),
    name: string().required(),
  }),
);
